import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { TikTokIcon } from './icons/TikTokIcon';

interface SocialLinksProps {
  facebook: string | null;
  instagram: string | null;
  tiktok: string | null;
  primaryColor: string;
}

const SocialLinks = ({ 
  facebook,
  instagram,
  tiktok,
  primaryColor
}: SocialLinksProps) => (
  <section className="py-12 bg-gray-50">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-4xl font-bold mb-4">Suivez-nous</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Restez connectés avec nous sur les réseaux sociaux
        </p>
      </div>
      <div className="flex justify-center items-center gap-8">
        {facebook && (
          <a 
            href={facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="p-4 rounded-full hover:scale-110 transition-all duration-300 shadow-lg"
            style={{ backgroundColor: primaryColor }}
          >
            <Facebook className="h-8 w-8 text-white" />
          </a>
        )}
        {instagram && (
          <a 
            href={instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="p-4 rounded-full hover:scale-110 transition-all duration-300 shadow-lg"
            style={{ backgroundColor: primaryColor }}
          >
            <Instagram className="h-8 w-8 text-white" />
          </a>
        )}
        {tiktok && (
          <a 
            href={tiktok}
            target="_blank"
            rel="noopener noreferrer"
            className="p-4 rounded-full hover:scale-110 transition-all duration-300 shadow-lg"
            style={{ backgroundColor: primaryColor }}
          >
            <TikTokIcon className="h-8 w-8 text-white" />
          </a>
        )}
      </div>
    </div>
  </section>
);

export default SocialLinks; 